import "./Description.css";
import React, { useEffect } from "react";
import { DescriptionModel } from "../../Classes/DescriptionModel";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Description = (description: DescriptionModel) => {
  const divChar = "|^";
  const englishRegex = /[\u0590-\u05FF]/;

  function checkLanguage() {
    const body = description.Body?.split("•").join("- ").split("–").join("-");
    const demands = description.Demands?.split("•")
      .join("- ")
      .split("–")
      .join("-");

    if (
      (description.Title && englishRegex.test(description.Title)) ||
      (body && englishRegex.test(body)) ||
      (demands && englishRegex.test(demands))
    ) {
      document.documentElement.dir = "rtl";
      const descriptionBody = document.getElementsByClassName(
        "description-body"
      )[0] as HTMLElement;
      if (descriptionBody) {
        descriptionBody.style.textAlign = "right";
      }
    } else if (description.Title) {
      document.documentElement.dir = "ltr";
      const descriptionBody = document.getElementsByClassName(
        "description-body"
      )[0] as HTMLElement;
      if (descriptionBody) {
        descriptionBody.style.textAlign = "left";
      }
    }
  }

  function handleText(text: string): string {
    return handleTextDivReplace(text);
  }

  function handleTextDivReplace(text: string): string {
    const bodyLines = text.split(divChar);
    return bodyLines.join("<br />");
  }

  function handleDescriptionText() {
    const bodyContainer = document.getElementsByClassName("body-text")[0] as
      | HTMLElement
      | undefined;
    const demandsContainer = document.getElementsByClassName(
      "demands-text"
    )[0] as HTMLElement | undefined;

    if (bodyContainer && demandsContainer) {
      if (description.Body?.includes(divChar)) {
        const bodyText = handleText(description.Body);
        bodyContainer.innerHTML = bodyText;
      } else if (description.Body) {
        bodyContainer.innerHTML = description.Body;
      }

      if (description.Demands?.includes(divChar)) {
        const demandsText = handleText(description.Demands);
        demandsContainer.innerHTML = demandsText;
      } else if (description.Demands) {
        demandsContainer.innerHTML = description.Demands;
      }
    }
  }

  useEffect(() => {
    handleDescriptionText();
    // checkLanguage();
  }, [description?.Body, description?.Demands, description?.Title]);

  return (
    <div className="container description-container">
      <h4 className="description-title">{description?.Title || ""}</h4>
      <div className="description-body">
        <div>
          {description?.Body ? (
            <div>תיאור התפקיד:</div>
          ) : (
            <Skeleton
              count={1}
              height={20}
              direction="rtl"
              width="50%"
              style={{ lineHeight: "30px" }}
            />
          )}
          {description?.Body ? (
            <div className="body-text"></div>
          ) : (
            <Skeleton
              count={2}
              height={20}
              direction="rtl"
              width="80%"
              style={{ lineHeight: "30px" }}
            />
          )}
        </div>
        <div>
          {description?.Demands ? (
            <div className="demands-title">דרישות התפקיד:</div>
          ) : (
            <Skeleton
              count={1}
              height={20}
              direction="rtl"
              width="50%"
              style={{ lineHeight: "30px" }}
            />
          )}
          {description?.Demands ? (
            <div className="demands-text"></div>
          ) : (
            <Skeleton
              count={2}
              height={20}
              direction="rtl"
              width="80%"
              style={{ lineHeight: "30px" }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Description;
